import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import { Badge, Popover } from 'reactstrap';
import ConversationsList from './ConversationsList';
import HorizontalTabs from '../../components/tabs/HorizontalTabs';
import chatStorage from './chatStorage';

class ChatSelector extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        <HorizontalTabs headers={[
          {
            content: (
              <div>
                {chatStorage.unreaded > 0 && (
                  <>
                    <Badge color="danger" id="unreaded-count">{chatStorage.unreaded}</Badge>
                  </>
                )}
                {chatStorage.conversationsList.length > 0 && <Badge color="secondary">{chatStorage.conversationsList.length}</Badge>}
                {chatStorage.notSubscribedCount > 0 && <Badge style={{ backgroundColor: 'rgba(200, 100, 100, .5)' }}>{chatStorage.notSubscribedCount}</Badge>}
                &nbsp;
                {t('Client chat')}
              </div>
            ),
          }, /* , { content: 'Internal chat' }, */
        ]}
        >
          <ConversationsList />
          <div className="alert-box">Internal</div>
        </HorizontalTabs>
      </div>
    );
  }
}

ChatSelector.propTypes = {};

export default translate(observer(ChatSelector));
